import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);

    // Set font based on theme
    if (theme === 'classic') {
      document.body.style.fontFamily = "'Montserrat', sans-serif";
    } else {
      document.body.style.fontFamily = "";  // Use CSS default
    }
  }, [theme]);

  const cycleTheme = () => {
    const themes = ['light', 'dark', 'classic'];
    const idx = themes.indexOf(theme);
    setTheme(themes[(idx + 1) % themes.length]);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, cycleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
